var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "message",
        `message--${_vm.message.role}`,
        {
          "message--wide": _vm.hasWideWidget,
          "message--full": _vm.pdpFullWidthWidget,
        },
      ],
      style: _vm.bubbleStyle,
    },
    [
      _vm.message.role === "assistant"
        ? _c("div", { staticClass: "message__author" }, [
            _c("svg", [
              _c("use", {
                attrs: {
                  width: "14",
                  height: "14",
                  href: "/img/icons/bot.svg#icon-bot",
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "message__content",
          class: { "message__content--has-save": _vm.canSaveToClipboard },
          style: _vm.hasWideWidget ? { flex: 1, minWidth: 0 } : {},
        },
        [
          _vm.canSaveToClipboard
            ? _c("div", { staticClass: "message__save-clipboard-wrap" }, [
                _c(
                  "button",
                  {
                    staticClass: "message__save-clipboard",
                    class: `message__save-clipboard--${_vm.message.role}`,
                    attrs: {
                      type: "button",
                      "aria-label": "Save to Clipboard",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onSaveToClipboard.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "message__save-clipboard-tooltip",
                        attrs: { role: "tooltip" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.clipboardSaved ? "Saved" : "Save to Clipboard"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.clipboardSaved
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("polyline", {
                              attrs: { points: "20 6 9 17 4 12" },
                            }),
                          ]
                        )
                      : _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("rect", {
                              attrs: {
                                width: "8",
                                height: "4",
                                x: "8",
                                y: "2",
                                rx: "1",
                                ry: "1",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                              },
                            }),
                          ]
                        ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("p", { domProps: { innerHTML: _vm._s(_vm.message.content) } }),
          _vm._v(" "),
          _vm.shouldShowProgress
            ? _c("div", { staticClass: "message__progress" }, [
                _c("div", {
                  staticClass: "message__progress-bar",
                  style: _vm.progressBarStyle,
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.visibleAttachments.length
            ? _c(
                "div",
                {
                  class: [
                    "message__attachments-grid",
                    "message__attachments-grid--" +
                      _vm.visibleAttachments.length,
                  ],
                },
                _vm._l(_vm.visibleAttachments, function (att, idx) {
                  return _c(
                    "div",
                    {
                      key: "attachment-" + idx,
                      staticClass: "message__attachment small",
                      on: {
                        click: function ($event) {
                          return _vm.onOpenAttachment(att)
                        },
                      },
                    },
                    [
                      att.type === "url"
                        ? [
                            _c("img", {
                              staticClass: "message__attachment-img",
                              attrs: {
                                src: att.payload,
                                alt: _vm.getFileName(att),
                              },
                            }),
                            _vm._v(" "),
                            att._mrhiCallouts &&
                            att._mrhiCallouts.type === "cambridge"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "message__attachment-cambridge-callouts",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "message__attachment-cambridge-flavor",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              att._mrhiCallouts.flavorText
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "message__attachment-cambridge-count",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              att._mrhiCallouts.countText
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            att.overlayUrl
                              ? _c("img", {
                                  staticClass:
                                    "message__attachment-product-overlay",
                                  attrs: {
                                    src: att.overlayUrl,
                                    alt: "Product preview",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "message__attachment-img-overlay",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "message__attachment-img-name",
                                  },
                                  [_vm._v(_vm._s(_vm.getFileName(att)))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            idx === 0 && _vm.shouldShowModeControl
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "message__attachment-mode",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "message__attachment-mode-icon",
                                        attrs: {
                                          type: "button",
                                          "aria-label": "Product image mode",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.toggleModePopover.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "16",
                                              height: "16",
                                              fill: "currentColor",
                                              viewBox: "0 0 16 16",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M7.765.13a.5.5 0 0 1 .47 0l7.5 4a.5.5 0 0 1 0 .882l-7.5 4a.5.5 0 0 1-.47 0l-7.5-4a.5.5 0 0 1 0-.882z",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("path", {
                                              attrs: {
                                                d: "m2.125 8.567-1.86.992a.5.5 0 0 0 0 .882l7.5 4a.5.5 0 0 0 .47 0l7.5-4a.5.5 0 0 0 0-.882l-1.86-.992-5.17 2.756a1.5 1.5 0 0 1-1.41 0z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.modePopoverOpen
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "message__attachment-mode-popover",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "message__attachment-mode-label",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Product image\n              "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "message__attachment-mode-buttons",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    class: [
                                                      "message__attachment-mode-btn",
                                                      {
                                                        "is-active":
                                                          _vm.currentProductMode ===
                                                          "separate",
                                                      },
                                                    ],
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.onSelectProductMode(
                                                          "separate"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Layered\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    class: [
                                                      "message__attachment-mode-btn",
                                                      {
                                                        "is-active":
                                                          _vm.currentProductMode ===
                                                          "integrated",
                                                      },
                                                    ],
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.onSelectProductMode(
                                                          "integrated"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  Static\n                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "message__attachment-file" },
                              [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "message__attachment-file-icon",
                                      `message__attachment-file-icon--${_vm.getFileExt(
                                        att
                                      )}`,
                                    ],
                                  },
                                  [
                                    _c("i", {
                                      class: _vm.getFileIconClass(att),
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "message__attachment-file-name",
                                  },
                                  [_vm._v(_vm._s(_vm.getFileName(att)))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "message__attachment-file-ext",
                                  },
                                  [_vm._v(_vm._s(_vm.getFileExt(att)))]
                                ),
                              ]
                            ),
                          ],
                      _vm._v(" "),
                      idx === _vm.maxVisible - 1 && _vm.remainingAttachments > 0
                        ? _c(
                            "div",
                            { staticClass: "message__attachment-remaining" },
                            [
                              _vm._v(
                                "\n          +" +
                                  _vm._s(_vm.remainingAttachments) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      att.type === "url"
                        ? _c(
                            "div",
                            {
                              staticClass: "message__attachment-download-icon",
                              attrs: { title: "Download" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.onDownloadAttachment(att)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "14",
                                    height: "14",
                                    fill: "currentColor",
                                    viewBox: "0 0 16 16",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.message.postContent
            ? _c("p", {
                staticClass: "mt-2",
                domProps: { innerHTML: _vm._s(_vm.message.postContent) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.message.imageUrl
            ? _c("img", {
                staticClass: "mt-2",
                staticStyle: { width: "200px", height: "auto" },
                attrs: { src: _vm.message.imageUrl, alt: "img" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.message.bannerResizeSettings
            ? _c(
                "div",
                { staticClass: "message__actions" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "secondary",
                        disabled: _vm.message.disabled,
                      },
                      on: {
                        click: _vm.onDuplicateTemplateAndPrepareResizeData,
                      },
                    },
                    [_vm._v("\n        Confirm\n      ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.message.proofLink
            ? _c("div", { staticClass: "message__actions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary btn-sm",
                    attrs: { disabled: _vm.message.disabled },
                    on: { click: _vm.onCopyProofLink },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-clipboard",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("\n        Copy\n      "),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.message.hasSelectButton
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary mt-2",
                  attrs: { disabled: _vm.message.disabled },
                  on: { click: _vm.onSelectProduct },
                },
                [_vm._v("\n      Select this product\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.message.productOptions &&
            _vm.message.productOptions.length > 0) ||
          _vm.message.hasOpenSelectorButton
            ? _c(
                "div",
                { staticClass: "mt-2 product-options-container" },
                [
                  _vm._l(_vm.message.productOptions, function (option) {
                    return _c(
                      "div",
                      {
                        key: option.id,
                        staticClass: "product-option",
                        class: {
                          "product-option--disabled": _vm.message.disabled,
                        },
                        on: {
                          click: function ($event) {
                            _vm.message.disabled
                              ? null
                              : _vm.onSelectProductOption(option)
                          },
                        },
                      },
                      [
                        _c("input", {
                          staticClass: "mr-2",
                          staticStyle: { cursor: "pointer" },
                          attrs: {
                            id: "option-" + option.id,
                            type: "radio",
                            name: "product-option-" + _vm.index,
                            disabled: _vm.message.disabled,
                          },
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "product-option-img",
                          attrs: {
                            src:
                              option.thumbnailUrl ||
                              option.full_url ||
                              option.path,
                            alt: "Product thumbnail",
                          },
                        }),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary btn-sm mt-3",
                      attrs: { disabled: _vm.message.disabled },
                      on: { click: _vm.onOpenProductSelector },
                    },
                    [
                      _vm._v(
                        "\n        View the product image selector...\n      "
                      ),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.message.widgets && _vm.message.widgets.length
            ? _c(
                "div",
                { staticClass: "mt-2 chat-widgets-container" },
                [
                  _vm._l(_vm.message.widgets, function (widget) {
                    return [
                      widget.type === "radio"
                        ? _c("AIChatWidgetRadio", {
                            key: "widget-" + widget.id,
                            attrs: {
                              options: widget.options,
                              disabled: _vm.message.disabled,
                              value:
                                _vm.getWidgetValue(widget.id) ||
                                (widget.options.length
                                  ? widget.options[0].value
                                  : null),
                            },
                            on: {
                              select: function ($event) {
                                return _vm.onWidgetRadioSelect(
                                  widget.id,
                                  $event
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "dropdown"
                        ? _c("AIChatWidgetDropdown", {
                            key: "widget-" + widget.id,
                            attrs: {
                              options: widget.options,
                              placeholder: widget.placeholder,
                              label: widget.label,
                              disabled: _vm.message.disabled,
                              visible: _vm.isWidgetVisible(widget),
                              value: _vm.getWidgetValue(widget.id),
                            },
                            on: {
                              select: function ($event) {
                                return _vm.onWidgetDropdownSelect(
                                  widget.id,
                                  $event
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "action_buttons"
                        ? _c("AIChatWidgetActionButtons", {
                            key: "widget-" + widget.id,
                            attrs: {
                              buttons: widget.buttons,
                              disabled: _vm.message.disabled,
                              "selected-action": widget.selectedAction || "",
                              stacked: widget.stacked || false,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "template_slider"
                        ? _c("AIChatWidgetTemplateSlider", {
                            key: "widget-" + widget.id,
                            attrs: {
                              templates: widget.templates,
                              disabled: _vm.message.disabled,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "template_gallery"
                        ? _c("AIChatWidgetTemplateGallery", {
                            key: "widget-" + widget.id,
                            attrs: {
                              templates: widget.templates,
                              "preselected-ids": widget.preselectedIds || [],
                              disabled: _vm.message.disabled,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "sequence_picker"
                        ? _c("AIChatWidgetSequencePicker", {
                            key: "widget-" + widget.id,
                            attrs: {
                              sources: widget.sources || [],
                              "initial-source-id": widget.initialSourceId || "",
                              "initial-selected-keys":
                                widget.initialSelectedKeys || [],
                              disabled: _vm.message.disabled,
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.onWidgetSequenceConfirm(
                                  widget.id,
                                  $event
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "mobile_hero_style_picker"
                        ? _c("AIChatWidgetMobileHeroStylePicker", {
                            key: "widget-" + widget.id,
                            attrs: {
                              header: widget.header,
                              cards: widget.cards || [],
                              "skip-action": widget.skipAction || "",
                              "skip-label":
                                widget.skipLabel || "Skip this image",
                              disabled: _vm.message.disabled,
                              "selected-action": widget.selectedAction || "",
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "reference_images_picker"
                        ? _c("AIChatWidgetReferenceImagesPicker", {
                            key: "widget-" + widget.id,
                            attrs: {
                              images: widget.images || [],
                              "base-product": widget.base_product || "",
                              disabled: _vm.message.disabled,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "pdp_image_set_picker" && !_vm.legacyPdpUi
                        ? _c("AIChatWidgetPdpImageSetPicker", {
                            key: "widget-" + widget.id,
                            attrs: {
                              rows: widget.rows || [],
                              "templates-by-subtype":
                                widget.templatesBySubtype &&
                                !Array.isArray(widget.templatesBySubtype)
                                  ? widget.templatesBySubtype
                                  : {},
                              "preset-sources": widget.presetSources || [],
                              "initial-preset-id": widget.initialPresetId || "",
                              "initial-size": widget.initialSize || "",
                              "product-label": widget.productLabel || "",
                              "product-image-url": widget.productImageUrl || "",
                              "own-image-result": widget.ownImageResult || null,
                              "brand-logo-result":
                                widget.brandLogoResult || null,
                              "product-image-result":
                                widget.productImageResult || null,
                              disabled: _vm.message.disabled,
                              "sequential-cursor":
                                widget.sequentialCursor != null
                                  ? widget.sequentialCursor
                                  : null,
                              "reference-mode": widget.referenceMode || false,
                              "brief-id": widget.briefId || null,
                              "brief-title": widget.briefTitle || "",
                            },
                            on: {
                              confirm: function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_row_picker_confirm:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                              "open-brief": function ($event) {
                                return _vm.onWidgetAction(
                                  widget.id,
                                  "brief_open_sidebar"
                                )
                              },
                              "open-brief-full": function ($event) {
                                return _vm.onWidgetAction(
                                  widget.id,
                                  "brief_open_full"
                                )
                              },
                              "open-gallery": function ($event) {
                                return _vm.onWidgetAction(
                                  widget.id,
                                  "pdp_open_design_gallery"
                                )
                              },
                              "own-image-request": function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_own_image_request:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                              "brand-logo-request": function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_brand_logo_request:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                              "product-image-request": function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_product_image_request:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                              "reference-submit": function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_reference_submit:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                              "row-update": function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_row_update:${JSON.stringify($event)}`
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "pdp_image_set_picker" && _vm.legacyPdpUi
                        ? _c("AIChatWidgetPdpImageSetPickerLegacy", {
                            key: "widget-legacy-" + widget.id,
                            attrs: {
                              rows: widget.rows || [],
                              "templates-by-subtype":
                                widget.templatesBySubtype &&
                                !Array.isArray(widget.templatesBySubtype)
                                  ? widget.templatesBySubtype
                                  : {},
                              "preset-sources": widget.presetSources || [],
                              "initial-preset-id": widget.initialPresetId || "",
                              "product-image-url": widget.productImageUrl || "",
                              "own-image-result": widget.ownImageResult || null,
                              "brand-logo-result":
                                widget.brandLogoResult || null,
                              disabled: _vm.message.disabled,
                              "reference-mode": widget.referenceMode || false,
                            },
                            on: {
                              confirm: function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_row_picker_confirm:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                              "open-gallery": function ($event) {
                                return _vm.onWidgetAction(
                                  widget.id,
                                  "pdp_open_design_gallery"
                                )
                              },
                              "own-image-request": function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_own_image_request:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                              "brand-logo-request": function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_brand_logo_request:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "pdp_scene_picker"
                        ? _c("AIChatWidgetPdpScenePicker", {
                            key: "widget-" + widget.id,
                            attrs: {
                              "row-index": widget.rowIndex,
                              "default-scene-prompt":
                                widget.defaultScenePrompt || "",
                              disabled: _vm.message.disabled,
                            },
                            on: {
                              composite: function ($event) {
                                _vm.onWidgetAction(
                                  widget.id,
                                  `pdp_scene_composite:${JSON.stringify(
                                    $event
                                  )}`
                                )
                              },
                              skip: function ($event) {
                                return _vm.onWidgetAction(
                                  widget.id,
                                  "pdp_scene_skip"
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "pdp_parallel_grid" &&
                      _vm.message._pdpParallelGrid &&
                      !_vm.legacyPdpUi
                        ? _c("AIChatWidgetPdpParallelGrid", {
                            key: "widget-" + widget.id,
                            attrs: {
                              grid: _vm.message._pdpParallelGrid,
                              "message-index": _vm.index,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "pdp_parallel_grid" &&
                      _vm.message._pdpParallelGrid &&
                      _vm.legacyPdpUi
                        ? _c("AIChatWidgetPdpParallelGridLegacy", {
                            key: "widget-legacy-" + widget.id,
                            attrs: {
                              grid: _vm.message._pdpParallelGrid,
                              "message-index": _vm.index,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "ab_hero_picker" &&
                      _vm.message._abHeroForm
                        ? _c("AIChatWidgetAbHeroPicker", {
                            key: "widget-" + widget.id,
                            attrs: {
                              rows: _vm.message._abHeroForm.rows || [],
                              generating:
                                _vm.message._abHeroForm.generating || false,
                              size: _vm.message._abHeroForm.size || "2000x2000",
                              "image-result":
                                _vm.message._abHeroForm.imageResult || null,
                              disabled: _vm.message.disabled,
                              "message-index": _vm.index,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                              "paste-image": function ($event) {
                                return _vm.$emit("widget-action", {
                                  widgetId: widget.id,
                                  action: {
                                    action: "ab_hero_paste",
                                    payload: $event,
                                  },
                                  messageIndex: _vm.index,
                                  message: _vm.message,
                                })
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "ab_hero" && _vm.message._abHeroForm
                        ? _c("AIChatWidgetAbHero", {
                            key: "widget-" + widget.id,
                            attrs: {
                              rows: _vm.message._abHeroForm.rows || [],
                              generating:
                                _vm.message._abHeroForm.generating || false,
                              size: _vm.message._abHeroForm.size || "2000x2000",
                              "image-result":
                                _vm.message._abHeroForm.imageResult || null,
                              result: _vm.message._abHeroResult,
                              disabled: _vm.message.disabled,
                              "message-index": _vm.index,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                              "paste-image": function ($event) {
                                return _vm.$emit("widget-action", {
                                  widgetId: widget.id,
                                  action: {
                                    action: "ab_hero_paste",
                                    payload: $event,
                                  },
                                  messageIndex: _vm.index,
                                  message: _vm.message,
                                })
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "ab_hero_result" &&
                      _vm.message._abHeroResult
                        ? _c("AIChatWidgetAbHeroResult", {
                            key: "widget-" + widget.id,
                            attrs: {
                              grid: _vm.message._abHeroResult,
                              "message-index": _vm.index,
                            },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      widget.type === "resolved_product_cards"
                        ? _c("AIChatResolvedProductCards", {
                            key: "widget-" + widget.id,
                            attrs: { references: widget.references || [] },
                            on: {
                              action: function ($event) {
                                return _vm.onWidgetAction(widget.id, $event)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.lightboxAttachment
        ? _c(
            "div",
            {
              staticClass: "message__lightbox",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeLightbox.apply(null, arguments)
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  return _vm.closeLightbox.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "message__lightbox-close",
                  attrs: { type: "button", "aria-label": "Close preview" },
                  on: { click: _vm.closeLightbox },
                },
                [_vm._v("\n      ×\n    ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "message__lightbox-stage" }, [
                _c("img", {
                  staticClass: "message__lightbox-img",
                  attrs: { src: _vm.lightboxAttachment.payload, alt: "" },
                }),
                _vm._v(" "),
                _vm.lightboxAttachment._mrhiCallouts &&
                _vm.lightboxAttachment._mrhiCallouts.type === "cambridge"
                  ? _c(
                      "div",
                      { staticClass: "message__lightbox-cambridge-callouts" },
                      [
                        _c(
                          "div",
                          { staticClass: "message__lightbox-cambridge-flavor" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.lightboxAttachment._mrhiCallouts
                                    .flavorText
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "message__lightbox-cambridge-count" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.lightboxAttachment._mrhiCallouts.countText
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.lightboxAttachment.overlayUrl
                  ? _c("img", {
                      staticClass: "message__lightbox-overlay",
                      attrs: {
                        src: _vm.lightboxAttachment.overlayUrl,
                        alt: "Product preview",
                      },
                    })
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }